import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import { getWordClassName, getBracket } from '../../../utils/shared/probeDetailUtils';
import { generateReactKey } from '../../../utils/shared/commonUtils';

const getLineClassName = (columnIndex, startIndex, length) => {
    let lineClassName = 'blue-line';
    if (length > 1) lineClassName = 'blue-line blended';
    return columnIndex >= startIndex && columnIndex < startIndex + length
        ? lineClassName
        : 'transparent-line';
};

const WordBox = props => {
    const {
        word,
        isSelfCorrected,
        isIncorrect,
        isHidden,
        isLastSelected,
        segments,
        columnIndex,
        selfCorrectedMark,
    } = props;
    return (
        <div className={`detail-box ${getWordClassName(isSelfCorrected, isIncorrect, isHidden)}`}>
            <div
                className={`detail-row ${getWordClassName(isSelfCorrected, isIncorrect, isHidden)}`}
            >
                {word}
                {getBracket(isLastSelected)}
                {isSelfCorrected ? <sup>{selfCorrectedMark}</sup> : null}
            </div>
            {isEmpty(segments) ? null : (
                <div className="line-wrap">
                    {segments.map(({ length, starting_phoneme: startIndex }, index) => (
                        <div
                            key={generateReactKey(index)}
                            className={getLineClassName(columnIndex, startIndex, length)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

WordBox.defaultProps = {
    word: '',
    isLastSelected: false,
    isSelfCorrected: false,
    isIncorrect: false,
    isHidden: false,
    segments: [],
    columnIndex: 0,
    selfCorrectedMark: 'sc',
};

WordBox.propTypes = {
    word: PropTypes.string,
    isLastSelected: PropTypes.bool,
    isSelfCorrected: PropTypes.bool,
    isIncorrect: PropTypes.bool,
    isHidden: PropTypes.bool,
    segments: PropTypes.array,
    columnIndex: PropTypes.number,
    selfCorrectedMark: PropTypes.string,
};

export default WordBox;
